import { render } from "./PaymentTypes.vue?vue&type=template&id=0fbc1ef5&scoped=true"
import script from "./PaymentTypes.vue?vue&type=script&lang=js"
export * from "./PaymentTypes.vue?vue&type=script&lang=js"

import "./PaymentTypes.vue?vue&type=style&index=0&id=0fbc1ef5&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fbc1ef5"]])

export default __exports__